module.exports = __webpack_public_path__ + "img/tarjetas.004c6c6f.png";